import { gql } from '@apollo/client';

const GET_ASSIGNABLE_ROLES = gql`
  query GetAssignableRoles($organizationId: Int, $orgUnitId: Int, $isFree: Boolean) {
    assignableRoles(organizationId: $organizationId, orgUnitId: $orgUnitId, isFree: $isFree) {
      Id
      DisplayName
    }
  }
`;

export default GET_ASSIGNABLE_ROLES;
